/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Arts9Inputs */

const en__field_enum_icsrm_arts9 = /** @type {(inputs: _Field_Enum_Icsrm_Arts9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arts, Music, Design or Fashion`)
};

const de__field_enum_icsrm_arts9 = /** @type {(inputs: _Field_Enum_Icsrm_Arts9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunst, Musik, Design & Mode`)
};

/**
* | output |
* | --- |
* | "Arts, Music, Design or Fashion" |
*
* @param {_Field_Enum_Icsrm_Arts9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_arts9 = /** @type {((inputs?: _Field_Enum_Icsrm_Arts9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Arts9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_arts9(inputs)
	return de__field_enum_icsrm_arts9(inputs)
});
export { _field_enum_icsrm_arts9 as "_field_enum_ICSRM_ARTS" }